import Relationships, { RelationshipSections } from './Relationships';

export default Relationships;
export { RelationshipSections };
